import useMediaQuery from '@/hooks/useMediaQuery'
import React from 'react'

type Props = {
  query: string
  clientOnly?: boolean
}

export const MediaQuery: React.FC<React.PropsWithChildren<Props>> = ({
  query,
  clientOnly = false,
  children,
}) => {
  const matches = useMediaQuery(query, clientOnly)

  return matches ? <>{children}</> : null
}
